


























































































































































import { Component, Vue } from "vue-property-decorator";
import {
  Image as VanImage,
  List,
  Skeleton,
  Tag,
  Toast,
  PullRefresh
} from "vant";
import dayjs from "dayjs";
import LiveReplyComment from "./LiveReplyComment.vue";
import { ILiveRoomItem } from "@/api/types";
import req from "@/api/portrait";
import { openUrl } from "@/common/utils";

@Component({
  components: { VanImage, Tag, LiveReplyComment, List, Skeleton, PullRefresh }
})
export default class LiveComment extends Vue {
  // 渲染的数据
  liveRoomList: ILiveRoomItem[] = [];
  // 列表下拉刷新
  refreshing = false;
  // 列表加载动画
  loading = true;
  finish = false;

  // 直播间与聊天室分页
  livePage = {
    lastReplyId: "",
    lastId: "",
    lastSortNo: "",
    lastCreateTime: ""
  };

  // 评论超过两条展示全部
  showMore = false;

  getLiveCommentImages(item: ILiveRoomItem) {
    return (item.imageHyperLink || []).map(data => data.image) || [];
  }

  mounted() {
    this.getLiveRoom();
  }

  initData() {
    this.liveRoomList = [];
    this.finish = false;
    this.livePage = {
      lastReplyId: "",
      lastId: "",
      lastSortNo: "",
      lastCreateTime: ""
    };
  }

  // 发布时间格式化
  timeFormat(time: string): string {
    if (!time) return "";
    const upTime = dayjs(time).unix() * 1000,
      nowTime = Date.now();

    if (nowTime - upTime > 365 * 24 * 3600 * 1000) {
      return dayjs(time).format("YYYY-MM-DD HH:mm");
    } else if (nowTime - upTime <= 3600 * 1000) {
      return ((nowTime - upTime) / 1000 / 60).toFixed(0) + "分钟前";
    } else if (nowTime - upTime <= 3600 * 1000 * 24) {
      return ((nowTime - upTime) / 1000 / 60 / 60).toFixed(0) + "小时前";
    } else {
      return dayjs(time).format("MM-DD HH:mm");
    }
  }

  // 获取直播间数据
  async getLiveRoom() {
    return req
      .getLiveRoom({
        infoClassifyId: this.$route.query.id as string,
        ...this.livePage
      })
      .then(res => {
        if (res.code === 0) {
          this.liveRoomList.push(...(res.data || []));
          if (!res.data) {
            this.finish = true;
            this.loading = false;
            return;
          }
          if (res.data.length) {
            const last = res.data[0];
            this.livePage.lastId = last.id + "";
            this.livePage.lastCreateTime = last.createTime;
            this.livePage.lastSortNo = last.sortNo + "";
          }
          if (res.data.length < 10) {
            this.finish = true;
          } else {
            this.finish = false;
          }
        } else {
          Toast.fail(res.message);
        }
      })
      .catch(err => {
        console.warn(err);
        Toast.fail("获取直播间信息失败！");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  // 打开关联新闻
  openNews(news: { title: string; url: string }) {
    openUrl(news.url);
  }

  // 上拉加载
  onLoad() {
    console.log(321);
    this.getLiveRoom();
  }

  // 下拉刷新
  onRefresh() {
    setTimeout(async () => {
      this.initData();
      await this.getLiveRoom();
      this.refreshing = false;
    }, 1000);
  }
}
